import React from 'react';

import Button from '../../Button';
import { getNavItem } from '../../../lib/nav';

import image from './home-boy@large.jpg';

import styles from './index.module.scss';

/* eslint-disable react/prop-types */
export default ({ locale }) => (
  <div className={styles.root}>
    <div className={styles.text}>
      <h2 className={styles.title}>{locale === 'en' ? 'The Kingston Difference' : '京斯敦與眾不同之處'}</h2>
      <p>
        {locale === 'en' ? (
          <React.Fragment>
            We provide a challenging and stimulating environment that nurtures the balanced development of students who,
            in their own unique way, grow into active and responsible world citizens.
          </React.Fragment>
        ) : (
          <React.Fragment>
            向學生提供一個具挑戰性和啟發性的環境，培養他們均衡發展，並使他們能以個人獨特的方式去成長為一個活躍主動和負責任的世界公民。
          </React.Fragment>
        )}
      </p>
      <Button
        className={styles.button}
        color="#fff"
        link
        to={`/${locale}${getNavItem('the-kingston-difference', 'mission-purpose-and-the-kingston-difference').uri}`}
      >
        {locale === 'en' ? 'Learn More' : '了解更多'}
      </Button>
    </div>
    <div className={styles.image} style={{ backgroundImage: `url(${image})` }} />
  </div>
);
